// @ts-check
import React from "react";
import moment from "moment-timezone";
import "./shift-details.css";

const ShiftDetails = (props) => {
  const {
    userCertificationIcons,
    assignmentEndDate,
    clockInOut,
    clockInOutEnabled,
    dontSendBack,
    dsb,
    formattedShiftDate,
    formattedShiftTime,
    handleFavorite,
    isClockedIn,
    isClockedOut,
    isFavorite,
    isUserDontSendBack,
    markAbsent,
    openCancelModal,
    openEditShiftModal,
    pastShift,
    reactAppUrl,
    selectedShift,
    shiftStatus,
    undoMarkAbsent,
    userCanPostJobs,
    userChat,
    viewProfileRedirect,
    showGroupMessage
  } = props;
  const getTooltipEnabled = () => {
    if (!userCanPostJobs) return false;
    const shiftStartDay = moment.tz(selectedShift.start_time, selectedShift.timezone);
    const today = moment().tz(selectedShift.timezone);
    const duration = moment.duration(shiftStartDay.diff(today));
    const hours = Math.floor(duration.asHours());
    // Shift must start today. Start time from now is 24 hours or less,
    // but shift hasn't started yet.
    return hours <= 24 && hours > 0;
  };

  const currentTime = moment(Date.now()).tz(selectedShift.timezone);
  const shiftInProgress = currentTime.isSameOrAfter(moment(selectedShift.start_time)
    .subtract(30, "minutes")) &&
    currentTime.isBefore(moment(selectedShift.end_time));
  const tooltipEnabled = getTooltipEnabled();
  const excused = selectedShift.excused;
  const cannotCancel = (!shiftInProgress && pastShift) || excused || !userCanPostJobs;
  const editShiftEnabled = false; // Should be enabled in P1

  const formattedAssignmentEndDate = moment.tz(assignmentEndDate, selectedShift.timezone).format("dddd, MMMM Do YYYY, h:mm a");

  return (
    <div data-testid="shift-details-modal">
      {/* ---- Header ---- */}
      <div className="shift-details-header">
        {/* ---- User Details info  ---- */}
        <div className="shift-details-flex">
          <img
            src={selectedShift.profile_url || "images/proffiller.png"}
            className="lg-avatar"
          />
          <div>
            <div
              className="shift-details-user-info"
              onClick={() => viewProfileRedirect(selectedShift.external_id)}
              data-pendo-key="roster-week-view-shifts-modal-user-profile-link-button"
            >
              <span className="shift-details-user-name">
                {selectedShift.fullname}
              </span>
              {/* ---- Covid Policy ---- */}
              <div className="flex-center-container">
                <div
                  className="roster-profile-subtitle flex-center-container"
                  style={{ marginLeft: "8px" }}
                >
                  {userCertificationIcons && userCertificationIcons.map((certification) => (
                    certification.has_icon && (
                      <div key={certification.icon_uri} className="certification-container" style={{ position: 'relative', display: 'inline-block' }}>
                        <img
                          src={certification.icon_uri}
                          className="certification-icon-img shift-details-certification-icon"
                          alt={certification.tooltip}/>
                        <div className="certification-icon-tooltip details-shift-tooltip shift-details-tooltip">{certification.tooltip}</div>
                      </div>
                    )
                  ))}
                </div>
              </div>
            </div>
            {/* ---- DSB ---- */}
            <div className="dsb-container">
              <span className="shit-status">{shiftStatus}</span>
              {
                isUserDontSendBack ? (
                  <span className="shit-status status-dsb">
                    Don’t send back
                  </span>
                ) : null
              }
            </div>
          </div>
        </div>

        {/* ---- Right section of header ---- */}
        <div className="shift-details-flex">
          {/* Favorite button */}
          <div
            className="shift-details-user-favorite"
            onClick={() => handleFavorite(selectedShift)}
            data-pendo-key="roster-week-view-shifts-modal-favorite-unfavorite"
          >
            <img
              className="shift-details-icon"
              src={isFavorite ?
                "images/roster/favorite-filled-icon.svg" :
                "images/roster/favorite-icon.svg"}
            />
          </div>
          {
            editShiftEnabled ?
             (
               <div
                 className="shift-details-button-container"
                 onClick={openEditShiftModal}
               >
                 <img
                   src={pastShift ?
                     "images/roster/edit-shift-icon-disabled.svg" :
                     "images/roster/edit-shift-icon.svg"
                   }
                   className={`shift-details-icon ${pastShift && 'disabled-button-icon'}`}
                 />
               </div>
             ) : null
          }
          {/* Chat button */}
          <div
            className="shift-details-button-container"
            onClick={showGroupMessage}
            data-pendo-key="roster-week-view-shifts-modal-message-button"
          >
            <div className='action-icon chat-icon'/>
          </div>
        </div>
      </div>
      {/* Shift details info */}
      <div className="divider-div"></div>
      <div className="shift-info-container">
        <div className="shift-info-section">
          {
            selectedShift.schedule_id ? (
              <a
                style={{ textDecoration: "none" }}
                href={`${reactAppUrl}/positions/${selectedShift.position_id}/edit`}
                data-pendo-key="roster-week-view-shifts-modal-position-link-button"
              >
                <span className="shift-info-font" style={{ fontWeight: "600" }}>
                  {selectedShift.positionName}
                </span>
              </a>
            ) : null
          }
          <span className="shift-date-info-font">
            Assignment ends {formattedAssignmentEndDate}
          </span>
        </div>
        <div className="divider-div"></div>
        <div className="shift-info-section">
          {
            selectedShift.schedule_id ? (
              <a
                style={{ textDecoration: "none" }}
                href={`${reactAppUrl}/schedules/${selectedShift.schedule_id}`}
                data-pendo-key="roster-week-view-shifts-modal-request-link-button"
              >
                <span className="shift-info-font">
                  Request {selectedShift.job_id}
                </span>
              </a>
            ) : null
          }
          <span className="shift-date-info-font">{formattedShiftDate}</span>
          <span className="shift-date-info-font">{formattedShiftTime}</span>
        </div>
      </div>
      <div className="divider-div"></div>
      {/* End of Shift details info */}
      <div className="shift-details-action-container">
        {/* Clock In/Out */}
        <div
          className={`shift-details-action-button ${!clockInOutEnabled && 'button-disabled'}`}
          onClick={() => clockInOutEnabled && clockInOut()}
          data-pendo-key="roster-week-view-shifts-modal-clock-in-out-button"
        >
          {
            isClockedIn ? ( 
              clockInOutEnabled ? 
                <div className='action-icon clock-out-icon'/> :
                <div className='action-icon clock-out-icon disabled'/>
            ) : null
          }
          {
            isClockedOut ? ( 
              clockInOutEnabled ? 
                <div className='action-icon clock-in-icon'/> :
                <div className='action-icon clock-in-icon disabled'/>
            ) : null
          }
          {
            isClockedIn ? (<span className="action-button-label">Clock-out</span>) : null
          }
          {
            isClockedOut ? (<span className="action-button-label">Clock-in</span>) : null
          }
        </div>
        {/* Mark Absent Buttons */}
        {
          selectedShift.category === "Marked Absent" ? (
            <div
              className="shift-details-action-button"
              onClick={undoMarkAbsent}
              data-pendo-key="roster-week-view-shifts-modal-undo-absent-button"
            >
              <div className="action-icon undo-icon" />
              <span className="action-button-label">Undo Absent</span>
            </div>
          ) : null
        }
        {
          selectedShift.category !== "Marked Absent" ? (
            <div
              className="shift-details-action-button"
              onClick={markAbsent}
              data-pendo-key="roster-week-view-shifts-modal-mark-absent-button"
            >
              <img src={"images/roster/mark-absent-icon.svg"} className="action-icon" />
              <span className="action-button-label">Mark Absent</span>
            </div>
          ): null
        }
        {/* End Mark Absent Buttons */}
        <div
          className={`shift-details-action-button ${tooltipEnabled && "button-tooltip"}`}
          data-pendo-key="roster-week-view-shifts-modal-cancel-shift-button"
        >
          <div
            className={`cancel-button shift-details-action-button ${cannotCancel && 'button-disabled'}`}
            onClick={(event) => !cannotCancel && openCancelModal(event, shiftInProgress)}
            data-testid="shift-details-cancel-button"
          >
            <img
              src={cannotCancel ?
                "images/roster/cancel-shift-disabled-icon.svg" :
                "images/roster/cancel-shift-icon.svg"}
              className="action-icon"
            />
            <span className="action-button-label">
              {cannotCancel ? "Cannot cancel" : "Cancel Shift"}
            </span>
          </div>
          <div className="details-shift-tooltip">
            <span>
              This shift starts within 24 hours. You will be billed for 4 hours
            </span>
          </div>
        </div>
        <div
          className={`shift-details-action-button ${dontSendBack && "dsb-disabled"}`}
          onClick={() => !dontSendBack && dsb()}
          data-pendo-key="roster-week-view-shifts-modal-dsb-button"
        >
          <img
            src={
            dontSendBack ?
              "images/roster/dsb-icon-disabled.svg" :
              "images/roster/dsb-icon.svg"
          }
            className="action-icon" />
          <span className="action-button-label">Don't send back</span>
        </div>
      </div>
    </div>
);
};

export default ShiftDetails;
